import React, { useState, useEffect, useCallback } from "react";
import "./Principal.scss";
import Slider from "../Slider/Slider";
import { SwiperSlide } from "swiper/react";
import Modal from "../Modal/Modal";

const Principal = (props) => {
  const [y, setY] = useState(window.scrollY);
  const [showStiky, setShowStiky] = useState("ocultar");
  const [modalOpen, setModalOpen] = useState(false);

  const handleNavigation = useCallback(
    (e) => {
      const window = e.currentTarget;
      if (y > window.scrollY) {
        if (window.scrollY <= 100) {
          setShowStiky("ocultar");
          console.log(y, "y");
          console.log(window.scrollY, "scrolly");
        }
      } else if (y < window.scrollY) {
        if (window.scrollY >= 100) {
          setShowStiky("mostrar");
          console.log(y, "y");
          console.log(window.scrollY, "scrolly");
        }
      }
      setY(window.scrollY);
    },
    [y]
  );
  useEffect(() => {
    setY(window.scrollY);
    window.addEventListener("scroll", handleNavigation);

    return () => {
      window.removeEventListener("scroll", handleNavigation);
    };
  }, [handleNavigation]);

  return (
    <div className="contenedor__principal">
      <div className="contenedor__principal_carousel">
        <Slider nav={false} pag={false}>
          <SwiperSlide>
  <div className="contenedor__principal_carousel__slider">
    <img src="./assets/Principal/1-desk.jpg" alt="Velasur exterior" />
    {/*<div className="overlay">
       <h2 className="overlay-text">
      CASAS Y TERRENOS RESIDENCIALES EN QUERÉTARO DESDE 1.9 MDP.
    </h2>
    <p className="overlay-text1">
      Ubicado en Corregidora, Velasur te ofrece un estilo de vida único con áreas verdes, alberca, casa club y más de 8,000 m² de parque lineal.
    </p>
      <div className="overlay-buttons">
        <a className="whatsappoverlay" href="https://api.whatsapp.com/send?phone=524428801675&text="><button className="btn-primary">¡Respuesta inmediata por Whatsapp!</button></a>
        <button 
  className="btn-secondary" 
  onClick={() => setModalOpen(true)}>
  Descarga el brochure
</button>
      </div>
    </div>*/}
  </div>
</SwiperSlide>

          <SwiperSlide>
            <div className="contenedor__principal_carousel__slider">
              <img src="./assets/Principal/2-desk.jpg" alt="Velasur exterior" />
              {/*<div className="overlay">
       <h2 className="overlay-text">
      CASAS Y TERRENOS RESIDENCIALES EN QUERÉTARO DESDE 1.9 MDP.
    </h2>
    <p className="overlay-text1">
      Ubicado en Corregidora, Velasur te ofrece un estilo de vida único con áreas verdes, alberca, casa club y más de 8,000 m² de parque lineal.
    </p>
      <div className="overlay-buttons">
        <a className="whatsappoverlay" href="https://api.whatsapp.com/send?phone=524428801675&text="><button className="btn-primary">¡Respuesta inmediata por Whatsapp!</button></a>
        <button 
  className="btn-secondary" 
  onClick={() => setModalOpen(true)}>
  Descarga el brochure
</button>
      </div>
    </div>*/}
            </div>
          </SwiperSlide>
          <SwiperSlide>
            <div className="contenedor__principal_carousel__slider">
              <img src="./assets/Principal/4-desk.jpg" alt="Velasur exterior" />
              {/*<div className="overlay">
       <h2 className="overlay-text">
      CASAS Y TERRENOS RESIDENCIALES EN QUERÉTARO DESDE 1.9 MDP.
    </h2>
    <p className="overlay-text1">
      Ubicado en Corregidora, Velasur te ofrece un estilo de vida único con áreas verdes, alberca, casa club y más de 8,000 m² de parque lineal.
    </p>
      <div className="overlay-buttons">
        <a className="whatsappoverlay" href="https://api.whatsapp.com/send?phone=524428801675&text="><button className="btn-primary">¡Respuesta inmediata por Whatsapp!</button></a>
        <button 
  className="btn-secondary" 
  onClick={() => setModalOpen(true)}>
  Descarga el brochure
</button>
      </div>
    </div>*/}
            </div>
          </SwiperSlide>
          <SwiperSlide>
            <div className="contenedor__principal_carousel__slider">
              <img
                src="./assets/Principal/img_velasur_9.jpg"
                alt="Velasur exterior"
              />
             {/*<div className="overlay">
       <h2 className="overlay-text">
      CASAS Y TERRENOS RESIDENCIALES EN QUERÉTARO DESDE 1.9 MDP.
    </h2>
    <p className="overlay-text1">
      Ubicado en Corregidora, Velasur te ofrece un estilo de vida único con áreas verdes, alberca, casa club y más de 8,000 m² de parque lineal.
    </p>
      <div className="overlay-buttons">
        <a className="whatsappoverlay" href="https://api.whatsapp.com/send?phone=524428801675&text="><button className="btn-primary">¡Respuesta inmediata por Whatsapp!</button></a>
        <button 
  className="btn-secondary" 
  onClick={() => setModalOpen(true)}>
  Descarga el brochure
</button>
      </div>
    </div>*/}
            </div>
          </SwiperSlide>
          <SwiperSlide>
            <div className="contenedor__principal_carousel__slider">
              <img
                src="./assets/Principal/img_velasur_8.jpg"
                alt="Velasur exterior"
              />
              {/*<div className="overlay">
       <h2 className="overlay-text">
      CASAS Y TERRENOS RESIDENCIALES EN QUERÉTARO DESDE 1.9 MDP.
    </h2>
    <p className="overlay-text1">
      Ubicado en Corregidora, Velasur te ofrece un estilo de vida único con áreas verdes, alberca, casa club y más de 8,000 m² de parque lineal.
    </p>
      <div className="overlay-buttons">
        <a className="whatsappoverlay" href="https://api.whatsapp.com/send?phone=524428801675&text="><button className="btn-primary">¡Respuesta inmediata por Whatsapp!</button></a>
        <button 
  className="btn-secondary" 
  onClick={() => setModalOpen(true)}>
  Descarga el brochure
</button>
      </div>
    </div>*/}
            </div>
          </SwiperSlide>
          <SwiperSlide>
            <div className="contenedor__principal_carousel__slider">
              <img
                src="./assets/Principal/img_velasur_3.jpg"
                alt="Velasur exterior"
              />
              {/*<div className="overlay">
       <h2 className="overlay-text">
      CASAS Y TERRENOS RESIDENCIALES EN QUERÉTARO DESDE 1.9 MDP.
    </h2>
    <p className="overlay-text1">
      Ubicado en Corregidora, Velasur te ofrece un estilo de vida único con áreas verdes, alberca, casa club y más de 8,000 m² de parque lineal.
    </p>
      <div className="overlay-buttons">
        <a className="whatsappoverlay" href="https://api.whatsapp.com/send?phone=524428801675&text="><button className="btn-primary">¡Respuesta inmediata por Whatsapp!</button></a>
        <button 
  className="btn-secondary" 
  onClick={() => setModalOpen(true)}>
  Descarga el brochure
</button>
      </div>
    </div>*/}
            </div>
          </SwiperSlide>
          <SwiperSlide>
            <div className="contenedor__principal_carousel__slider">
              <img
                src="./assets/Principal/img_velasur_13.jpg"
                alt="Velasur exterior"
              />
             {/*<div className="overlay">
       <h2 className="overlay-text">
      CASAS Y TERRENOS RESIDENCIALES EN QUERÉTARO DESDE 1.9 MDP.
    </h2>
    <p className="overlay-text1">
      Ubicado en Corregidora, Velasur te ofrece un estilo de vida único con áreas verdes, alberca, casa club y más de 8,000 m² de parque lineal.
    </p>
      <div className="overlay-buttons">
        <a className="whatsappoverlay" href="https://api.whatsapp.com/send?phone=524428801675&text="><button className="btn-primary">¡Respuesta inmediata por Whatsapp!</button></a>
        <button 
  className="btn-secondary" 
  onClick={() => setModalOpen(true)}>
  Descarga el brochure
</button>
      </div>
    </div>*/}
            </div>
          </SwiperSlide>
        </Slider>
      </div>
      <div className="bottom_info">
        <div className="icon-scroll"></div>
        <div className="whatsapp">
          {/*<div className={showStiky}>
            <a
              target={"_blank"}
              href="https://api.whatsapp.com/send?phone=524428801675&text="
            >
              <img src="/assets/Logos/svg-icon-whatsapp.svg" alt="Whatsapp" />
            </a>
          </div>*/}
          <a
        id="ws_script"
        href="https://api.whatsapp.com/send?phone=524461340798&text=¡Hola! Me gustaría recibir información de Velasur"
        target="_blank"
        rel="noopener noreferrer"
      >
        <img
          src="https://multipagos.velasresorts.com/images/WhatsApp_Logo_1.png"
          width="65"
          height="65"
          alt="WhatsApp"
        />
      </a>
        </div>
        <div className="texto">
          <p>LOTES RESIDENCIALES PREMIUM</p>
        </div>
      </div>
      {modalOpen && <Modal setModal={setModalOpen} />} {/* Renderiza el modal */}
    </div>
  );
};

export default Principal;
